export function get_cookie_name(token) {
    return 'osc-' + token;
}